import React from 'react'
import Sidebar from "../Sidebar/Sidebar"
import PostCard from '../../../../Components/PostCard'
import { useState } from 'react'

const Dashboard = () => {
  return (
    <>
    <div className="bg-[#F3F2EF] mt-14 ">
    <div className="container mx-auto py-8 gap-4 sm:px-6">
    <div className="flex px-2">
        <Sidebar />
        <div className="w-3/4 mx-4">
          <div className="bg-white p-4 rounded-lg shadow mb-6">
            <h2 className="font-semibold text-xl mb-1">Today's actions</h2>
            <p className="text-sm text-gray-500">Pages that complete these actions regularly grow 4x faster</p>
            <div className="mt-4 space-y-2">
              <div className="bg-gray-100 rounded p-2 rounded">
                <p className="text-lg font-semibold">Add services to your company page</p>
                <div className='flex justify-between items-center'>
                <p className="text-sm text-gray-400">Let potential clients know about services from your company page.{" "}</p>
                    <button className="text-blue-600 text-sm">Add services</button>
                </div>
              </div>
              <div className="p-2 bg-gray-100 rounded">
                <p className="text-lg font-semibold">Follow other Pages</p>
                <div className='flex justify-between items-center'>
                <p className="text-sm text-gray-400">Follow other pages to stay connected to your industry and join relevant conversations.{" "}</p>

                <button className="text-blue-600 text-sm">Follow</button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow mb-6">
            <div className='p-4'>
            <h2 className="font-semibold text-xl">Manage recent posts</h2>
            <p className="text-sm text-gray-500 mb-6">Manage your page's content and amplify your reach with boosting.</p>
            <div className="flex space-x-4 overflow-x-auto py-2">
              <PostCard
                content="On this Good Friday, let's pause, reflect, and reboot our hearts with kindness and hope. Wishing you a meaningful day from the LogicSpice family! #GoodFriday #LogicSpice"
                image="/Images/newsfeed/RightBannerCard.png"
                reactions="62"
                comments="0"
              />
              <PostCard
                content="AI is more than just writing code—it's changing how we build, test, and launch software. Learn more in our latest blog! #AI #SoftwareDevelopment"
                image="/Images/newsfeed/Dense-Forest-Wallpaper-HD-with-towering-evergreens-and-soft-light-filtering-through-the-fog.jpg"
                reactions="4"
                comments="2"
              />
              {/* <PostCard
                content="Our latest blog is out! What is blockchain? #Blockchain #Tech"
                reactions="2"
                comments="0"
              /> */}
            </div>
            </div>
            
            <div className="border text-center p-4 rounded-b-lg">
            <a href="#" className="text-gray-600 text-sm font-semibold">Show all page posts{" "}<i class="fa fa-arrow-right"></i></a>

            </div>
          </div>

          <div className="bg-white p-4 rounded-lg shadow mb-6">
            <h2 className="font-semibold text-xl">New! Showcase your services</h2>
            <p className="text-sm text-gray-500 mb-2">Showcase your services on your profile and attract leads with Premium</p>
            <button className="bg-blue-600 text-white py-1 px-4 rounded-full mt-2">Add services</button>
          </div>

          <div className="bg-white p-4 rounded-lg shadow mb-6">
            <h2 className="font-semibold text-xl">Track performance</h2>
            <p className="text-sm text-gray-500">Grow your page 3x faster leveraging insights and analytics</p>
            <div className="grid grid-cols-4 gap-4 mt-4">
              <div className='bg-gray-100 p-4 rounded'>
                <p className="text-2xl font-semibold">304</p>
                <p className="text-sm text-gray-600">Search appearance</p>
                <p className="text-sm text-gray-500"><span className="text-green-600 font-semibold">▲30.5%</span> last 7 days</p>
              </div>
              <div className='bg-gray-100 p-4 rounded'>
                <p className="text-2xl font-semibold">8</p>
                <p className="text-sm text-blue-600 font-semibold">New followers</p>
                <p className="text-sm text-gray-500"><span className="text-red-600 font-semibold">▼95.8%</span> last 7 days</p>
              </div>
              <div className='bg-gray-100 p-4 rounded'>
                <p className="text-2xl font-semibold">98</p>
                <p className="text-sm text-blue-600 font-semibold">Post impressions</p>
                <p className="text-sm text-gray-500"><span className="text-red-600 font-semibold">▼57%</span> last 7 days</p>
              </div>
              <div className='bg-gray-100 p-4 rounded'>
                <p className="text-2xl font-semibold">27</p>
                <p className="text-sm text-blue-600 font-semibold">Page visitors</p>
                <p className="text-sm text-gray-500"><span className="text-red-600 font-semibold">▼69%</span> last 7 days</p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="font-semibold text-xl">Join conversations</h2>
            <p className="text-sm text-gray-500">Build brand awareness and community by engaging with recent conversations</p>
            <div className="text-center py-6">
                <img src="/Images/business/company/empty.svg" alt="No conversations" className="mx-auto mb-4" />
              <p className="text-gray-900 font-semibold text-2xl mb-4">Your feed is empty</p>
              <p className="text-sm text-gray-500 mb-2">Follow other Pages in your industry to get new inspiration</p>
              <button className="border border-blue-600 text-blue-600 font-semibold py-1 px-4 rounded-full mt-2">+ Add pages to follow</button>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </>
  )
}

export default Dashboard